import { FormattedDate } from "tree-wallet-client";

function formatDateFromTimestamp (date: number) {
  const dateObj = new Date(date);
  return formatDate(dateObj);
}

export function formatDate (dateObj: Date): FormattedDate {
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  const day = ("0" + (dateObj.getDate())).slice(-2);
  const year = dateObj.getFullYear().toString();
  const timezone = dateObj.toTimeString().match(/GMT.\d+/)

  return {
    date: `${day}/${month}/${year}`,
    time: `${getUTCTime(dateObj)}`,
    timezone
  };
}

function parseDate(date: string) {
  let parsedDate: any = Date.parse(date);
  if (isNaN(parsedDate)) {
    // split string and create array.
    const arr: any = date.split(/-|\s|:/);
    // decrease month value by 1
    parsedDate = new Date(arr[0], arr[1] -1, arr[2], arr[3], arr[4], arr[5]);
  }
  return parsedDate;
}

function getTimeDifference(date1: Date, date2: Date) {
  return Math.abs(date2.getTime() - date1.getTime());
}

function getUTCTime(date = new Date()) {
  const padTo2Digits = (num: number) => {
    return num.toString().padStart(2, '0');
  }

  return [
    padTo2Digits(date.getUTCHours()),
    padTo2Digits(date.getUTCMinutes()),
    padTo2Digits(date.getUTCSeconds()),
  ].join(':');
}

const methods = {
  parseDate,
  formatDateFromTimestamp,
  formatDate,
  getTimeDifference,
  getUTCTime
};

export default methods;